<template>
  <!-- top headers -->
  <section>
    <div class="top-header">
      <div class="m-container">
        <div class="row">
          <div class="col-12 col-sm-4 wro-logo">
            <div class="logo-wrapper">
              <!-- <img :src="logo"> -->
              <img src="@/assets/img/wro-logo.svg">
            </div>
          </div>
          <div class="col-12 col-sm-8  right-part">
            <div class="social">
              <i class="fab fa-twitter" @click="redirectTo($store.state.settings_website[0].twitter)"></i>
              <i class="fab fa-facebook-f" @click="redirectTo($store.state.settings_website[0].facebook)"></i>
              <i class="fab fa-instagram" @click="redirectTo($store.state.settings_website[0].instagram)"></i>
              <!-- <i class="fab fa-telegram" @click="redirectTo($store.state.settings_website[0].telegram)"></i>                             -->
              <i class="fab fa-linkedin-in" @click="redirectTo('')"></i>
            </div>
            <div class="mail-us">
              <i class="far fa-envelope"></i>
              <span>{{this.$store.state.settings_website[0].email}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- end top headers -->
</template>

<script>
export default {
  data:() => ({
    logo: null
  }),
  mounted() {
    this.logo = this.$store.state.InternalSettings[0].logo
  },
  methods:{
    redirectTo(link){
      window.open(link,'_blank');
    }
  }
}
</script>

<style>
/*** Top header style ***/

.top-header{
  background: #ffffff;
  padding: 10.8px;
}

.top-header .row{
  align-items: center;
}

.top-header .right-part{
  display: flex;
  justify-content: flex-end;
  color: var(--mainColors);
}

.top-header .right-part  .social{
  border-right: 2px solid var(--mainColors);
  margin-right: 21px;
  padding: 5px 0;
}
.top-header .right-part .social i{
  margin-right: 22px;
  font-size: 18px;
  cursor: pointer;
}

.top-header .right-part  .mail-us{
  color: #7C7C7C;
  font-weight: 500;
  padding: 5px 0;
}
.top-header .right-part .mail-us span{
  font-size: 12px;
}
.top-header .right-part .mail-us i{
  margin-right: 6px;
  font-size: 15px;
  color: var(--mainColors);
}
@media (max-width: 580px) {
.top-header .right-part{ position:relative }
}
/** End top header style ***/

@media (min-width:412px ) and (max-width: 602px){
  .right-part{
    position: absolute;
    right: 15px;
  }

}
@media (max-width: 356px) {
  .top-header .m-container{
    padding: 0px;
  }
  .top-header .m-container .wro-logo{
    margin-bottom: 13px;
  }
}

.wro-logo img {
  height: 22px;
  width: auto;
  object-fit: contain;
}
</style>